var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-items-center form-control-stock-quantity-container",
    },
    [
      _c("input", {
        staticClass: "form-check-input",
        attrs: { id: _vm.field.id, type: "checkbox" },
        domProps: { checked: _setup.isTracked },
        on: { click: _setup.handleTrackStockToggle },
      }),
      _vm._v(" "),
      _c(_setup.FormControlTypeNumber, {
        ref: "innerInputComponentRef",
        staticClass: "ms-2",
        attrs: {
          "current-data": _vm.currentData,
          field: _vm.field,
          "form-id": _vm.formId,
        },
      }),
      _vm._v(" "),
      _setup.basketCount && _setup.isTracked
        ? _c(
            "span",
            {
              staticClass:
                "ms-2 badge bg-info-subtle text-info border border-info-subtle px-2 py-1 small",
            },
            [
              _vm._v(
                "\n        Basket count: " +
                  _vm._s(_setup.basketCount) +
                  "\n    "
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }